import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../hooks/useTheme";
import { Lock, Ticket } from "lucide-react";

/**
 * Shown in place of a premium coach feature (Coach Reporting, My Program) when
 * the coach is on a free/basic account. Mirrors the CSI locked-upsell style and
//old  * points the coach to My Membership, where they can enter a referral code or
 * points the coach to the coach plans page, where they can enter a promo code or
 * upgrade.
 */
export default function CoachUpgradeGate({ featureName = "This feature" }) {
    const { isDarkMode } = useTheme();
    const navigate = useNavigate();

    const card = isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200";
    const heading = isDarkMode ? "text-slate-100" : "text-slate-900";
    const sub = isDarkMode ? "text-slate-400" : "text-slate-600";
    const iconBox = isDarkMode ? "border-slate-600 bg-slate-700/50" : "border-slate-200 bg-slate-50";

    return (
        <div className={`min-h-screen flex items-center justify-center px-4 ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
            <div className={`rounded-2xl border shadow-sm p-8 md:p-10 max-w-lg w-full flex flex-col items-center text-center ${card}`}>
                <div className={`w-14 h-14 rounded-full border flex items-center justify-center mb-4 ${iconBox}`}>
                    <Lock size={26} className={isDarkMode ? "text-blue-400" : "text-blue-500"} />
                </div>
                <h1 className={`text-xl md:text-2xl font-bold ${heading}`}>{featureName} is a premium feature</h1>
                <p className={`mt-2 text-sm max-w-md ${sub}`}>
                    {/* old Upgrade your coach membership to unlock it. Have a referral code? Enter it on */}
                    {/* old your membership page to unlock instantly. */}
                    {/* The code box is on the plans page (My Membership has none); Pono Pilot's codes are promo codes */}
                    Upgrade your coach membership to unlock it. Have a promo code? Enter it on
                    the plans page to unlock instantly.
                </p>
                <button
                    //old onClick={() => navigate("/coaching/membership")}
                    onClick={() => navigate("/coaching/membership/plans")}
                    className="mt-5 inline-flex items-center gap-2 rounded-xl bg-primary-600 px-6 py-2.5 font-semibold text-white shadow-lg shadow-primary-600/30 hover:bg-primary-700 transition-colors"
                >
                    <Ticket size={18} />
                    {/* old Go to My Membership */}
                    View Plans
                </button>
            </div>
        </div>
    );
}
